import React from "react";
import classes from "./SentimentChangePercent.module.css";

const LargestSentimentMovementBar = ({ concept, last = false }) => {
    return (
        <div className={classes.sentimentBarBlock}>
            <div style={{ display: "flex", columnGap: "5px", minWidth: "90px", marginRight: "10px" }}>
                <span style={{ color: "#F0552D" }}>
                     {(concept.negative * 100).toFixed(0)}%
                </span>
                <span style={{ color: "#C7D0C7" }}>
                     {(concept.neutral * 100).toFixed(0)}%
                </span>

                <span style={{ color: "#0F62FE" }}>
                    {(concept.positive * 100).toFixed(0)}%
                </span>
            </div>
            <div className={classes.sentimentBarContainer} style={{
                height: `${last ? "16px" : " 16px"}`,
            }}>
                <div
                    className={classes.sentimentBar}
                    style={{
                        opacity: `${last ? "0.6" : "1"}`,
                        height: `${last ? "16px" : "16px"}`,
                        width: `${(concept.negative * 100).toFixed(0)}%`,
                        borderRadius: "2px",
                        background: "#F0552D",
                    }}
                    title={`${(concept.negative * 100).toFixed(0)} %`}
                />
                <div
                    className={classes.sentimentBar}
                    style={{
                        opacity: `${last ? "0.6" : "1"}`,
                        height: `${last ? "16px" : " 16px"}`,
                        width: `${(concept.neutral * 100).toFixed(0)}%`,
                        borderRadius: "2px",
                        background: "#C7D0C7",
                    }}
                    title={`${(concept.neutral * 100).toFixed(0)} %`}
                />

                <div
                    className={classes.sentimentBar}
                    style={{
                        opacity: `${last ? "0.6" : "1"}`,
                        height: `${last ? "16px" : " 16px"}`,
                        width: `${(concept.positive * 100).toFixed(0)}%`,
                        borderRadius: "2px",
                        background: "#0F62FE",
                    }}
                    title={`${(concept.positive * 100).toFixed(0)} %`}
                />
            </div>
        </div>
    );
};

export default LargestSentimentMovementBar;
